<template>
  <div class="min-h-screen bg-background">
    <PageHeader />

    <main>
      <!-- Top Banner -->
      <div class="bg-[#7c2622] py-16">
        <div class="mx-auto max-w-[1400px] px-8 lg:px-12">
          <h1 class="font-serif text-3xl lg:text-4xl text-white">
            Award Categories
          </h1>
          <p class="text-white/70 mt-2">
            Six categories of recognition across the souvenir industry.
          </p>
        </div>
      </div>

      <!-- Content -->
      <section class="py-20 lg:py-28 bg-gray-50">
        <div class="mx-auto max-w-[1400px] px-8 lg:px-12">

          <div class="max-w-2xl mb-16 animate-fade-in">
            <p class="text-sm font-medium tracking-widest uppercase text-gray-500 mb-4">
              Award Categories
            </p>

            <h2 class="font-serif text-3xl lg:text-4xl text-foreground mb-4">
              Categories of Recognition
            </h2>

            <p class="text-gray-600">
              Awards are conferred across six distinct categories, each
              representing a critical dimension of excellence in the souvenir industry.
            </p>
          </div>

          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 gap-6">
            <div
              v-for="(category, index) in categories"
              :key="category.title"
              class="bg-white border border-gray-200 p-8 animate-fade-in hover:border-[#7c2622]/40 transition-colors"
              :style="{ animationDelay: index * 0.1 + 's' }"
            >
              <div class="flex items-start gap-4 mb-4">
                <span class="text-sm font-medium text-gray-400">
                  0{{ index + 1 }}
                </span>

                <h3 class="font-serif text-xl text-foreground">
                  {{ category.title }}
                </h3>
              </div>

              <p class="text-sm text-gray-600 leading-relaxed">
                {{ category.description }}
              </p>
            </div>
          </div>

        </div>
      </section>
    </main>

    <PageFooter />
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"
import PageFooter from "@/components/PageFooter.vue"

export default {
  name: "Categories",
  components: {
    PageHeader,
    PageFooter,
  },
  data() {
    return {
      categories: [
        {
          title: "Best Souvenir Retailer",
          description:
            "Recognising retail establishments with exceptional product curation, store presentation, and customer experience standards.",
        },
        {
          title: "Artisan Craftsmanship",
          description:
            "Honouring artisans and craftspeople who demonstrate exceptional skill in creating authentic, handcrafted souvenirs.",
        },
        {
          title: "Cultural Authenticity",
          description:
            "Acknowledging businesses that excel in representing local heritage, traditions, and cultural narratives through their products.",
        },
        {
          title: "Sustainable Practices",
          description:
            "Celebrating commitment to environmentally responsible sourcing, production, and packaging in souvenir operations.",
        },
        {
          title: "Innovation in Souvenirs",
          description:
            "Recognising creative approaches to souvenir design that balance tradition with contemporary appeal and functionality.",
        },
        {
          title: "Tourism Partnership",
          description:
            "Honouring businesses that contribute significantly to the tourism ecosystem through collaboration and visitor engagement.",
        },
      ],
    }
  },
}
</script>